export let silenceSymbol = '-'
export let smartEditSilenceThreshold = 2
export function isSilenceSymbol(text) {
  if (text === silenceSymbol || text === '_ ' || text === '- ') {
    return true
  }
  return false
}
